export default __webpack_public_path__ + "static/media/homepage-hero-2.c5bec69c.png";